export default function snap(value, point) {
	return Math.round(value / point) * point;
}
